import { FASTElement as d, attr as o } from "@microsoft/fast-element";
import { aiChipStyles as h } from "./ai-chip.styles.js";
import { aiChipTemplate as p } from "./ai-chip.template.js";
import f from "./ai-chip.i18n.js";
import { NumberStringConverter as m } from "../common/converters/number-string-converter.js";
import { JsonValueConverter as g } from "../common/converters/json-value-converter.js";
var v = Object.defineProperty, l = (u, t, e, s) => {
  for (var i = void 0, a = u.length - 1, r; a >= 0; a--)
    (r = u[a]) && (i = r(t, e, i) || i);
  return i && v(t, e, i), i;
};
const c = class c extends d {
  constructor() {
    super(...arguments), this.confidence = 0, this.i18n = f, this.isExpanded = !1, this.suggestions = [], this.removedSuggestions = [];
  }
  handleSuggestionClick() {
    this.$emit("apply", null, { cancelable: !1 });
  }
  handleDismissClick() {
    this.$emit("dismiss", null, { cancelable: !1 });
  }
  toggleDropMenu() {
    this.isExpanded = !this.isExpanded;
  }
  handleFocusOut() {
    this.isExpanded = !1;
  }
  selectSuggestion(t) {
    this.previousSuggestion && (this.suggestions.push(this.previousSuggestion), this.removedSuggestions = this.removedSuggestions.filter(
      (s) => {
        var i;
        return s.value !== ((i = this.previousSuggestion) == null ? void 0 : i.value) || s.confidence !== this.previousSuggestion.confidence;
      }
    )), this.previousSuggestion = t, this.selectedValue = t.value, this.confidence = t.confidence;
    const e = this.suggestions.findIndex(
      (s) => s.value === t.value && s.confidence === t.confidence
    );
    e !== -1 && (this.removedSuggestions.push(this.suggestions[e]), this.suggestions.splice(e, 1)), this.isExpanded = !1, this.$emit(
      "suggestionSelected",
      { selectedValue: this.selectedValue, label: this.label },
      { cancelable: !1 }
    );
  }
  initializeComponent() {
    if (this.suggestions && this.suggestions.length > 0) {
      if (this.selectedValue) {
        const e = this.suggestions.find(
          (s) => s.value === this.selectedValue
        );
        if (e) {
          this.selectSuggestion(e);
          return;
        }
      }
      const t = this.suggestions.reduce(
        (e, s) => s.confidence > e.confidence ? s : e
      );
      this.selectSuggestion(t);
    }
  }
  connectedCallback() {
    super.connectedCallback(), setTimeout(() => {
      this.initializeComponent();
    }, 0);
  }
};
c.definition = {
  name: "ai-chip",
  template: p,
  styles: h
};
let n = c;
l([
  o({ converter: m })
], n.prototype, "confidence");
l([
  o
], n.prototype, "label");
l([
  o({ converter: g })
], n.prototype, "i18n");
l([
  o
], n.prototype, "selectedValue");
l([
  o({ mode: "boolean" })
], n.prototype, "isExpanded");
l([
  o({ converter: g })
], n.prototype, "suggestions");
export {
  n as AiChip
};
